import { render, staticRenderFns } from "./TgSpecialSwiper.vue?vue&type=template&id=1243d78e&"
import script from "./TgSpecialSwiper.vue?vue&type=script&lang=js&"
export * from "./TgSpecialSwiper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports